export enum UserRole {
  superUser = "super_user",
  admin = "admin",
  worker = "worker",
  dataReader = "data_reader",
  agent = "agent",
  customerSupportAgent = "customer_support_agent",
  claimsAdjudicator = "claims_adjudicator",
  finance = "finance",
  none = "none",
}
